module.exports = __webpack_public_path__ + "resources/img/img_ai_fashion2_en_m.2274e091b0a88ea0b4d95a05e737ce5d.png";